import axios from "axios";
import { atom } from "jotai";
import { SetStateAction } from "jotai/core/types";
import { atomFamily } from "jotai/utils";

import { getLanderQuizQuestions } from "./lander-quiz.constants";
import {
  LanderQuiz,
  LanderQuizFinished,
  LanderQuizQuestion,
} from "./lander-quiz.types";

export const landerQuizFinishedAtom = atom<boolean>(async () => {
  try {
    const submission = window.theme.Sweepstake.prototype.retrieveSubmission();
    const userEmail = submission?.data?.email;
    const { data }: { data: LanderQuizFinished } = await axios.get(
      `${window.FKL.yentaServicesApiUrl}/profile/${
        userEmail ? encodeURIComponent(userEmail) : "no-email"
      }`
    );
    return !!data.skip_demo_quiz;
  } catch (error) {
    console.error(error.response?.data?.message ?? error.message);
    return false;
  }
});

export const landerQuizAtom = atom<LanderQuiz, SetStateAction<LanderQuiz>>(
  () => {
    return {
      questions: getLanderQuizQuestions().map((question) => ({
        ...question,
        options: question.options?.map((option) => ({
          ...option,
          isSelected: false,
        })),
        answer: null,
      })),
    } as LanderQuiz;
  },
  (get, set, update) => {
    const updatedLanderQuiz =
      typeof update === "function" ? update(get(landerQuizAtom)) : update;
    set(landerQuizAtom, updatedLanderQuiz);
  }
);

export const currentQuestionIndexAtom = atom<number>(0);

export const landerQuizQuestionAtom = atomFamily<
  number,
  LanderQuizQuestion,
  SetStateAction<LanderQuizQuestion>
>((questionIndex) =>
  atom(
    (get) => {
      return get(landerQuizAtom).questions[questionIndex];
    },
    (_get, set, update) => {
      set(landerQuizAtom, (quiz) => ({
        ...quiz,
        questions: quiz.questions.map((question, index) =>
          index !== questionIndex
            ? question
            : typeof update === "function"
            ? update(question)
            : update
        ),
      }));
    }
  )
);

export const branchedQuestionsCountAtom = atom<number>(0);

export const showLoadingSpinnerAtom = atom<boolean>(false);
